export default __webpack_public_path__ + "static/media/micro-icon.a426e93d.svg";